import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Menu, Dropdown, Input, Button, Avatar} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import LogoutModal from './LogoutModal'

import style from './profile.sass'

@inject('store') @observer
class Profile extends Component {
  state = {
    dropdown: false,
    modal: false
  }
  openModal = () => {
    this.setState({modal: true})
  }
  closeModal = () => {
    this.setState({modal: false})
  }
  handleVisibleChange = (visible) => {
    this.setState({dropdown: visible})
  }
  handleMenuClick = (e) => {
    if (e.key !== '2') {
      this.setState({dropdown: false})
    }
  }
  handleChange = (e) => {
    this.props.store.user.setHijackEmail(e.target.value)
  }
  hijack = (e) => {
    e.preventDefault()
    this.props.store.user.hijack()
  }
  render() {
    const {user} = this.props.store
    const {first_name, last_name, username, email, is_staff, is_hijacked, billing_plan} = user.data
    const plan = billing_plan.name
    const hijack = is_staff && !is_hijacked
    const name = first_name || username || last_name || email
    const letter = name?.slice(0,1) || ''
    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key='0'>
          <Link to='/profile'>
            <FontAwesomeIcon icon='user'/> Profile
          </Link>
        </Menu.Item>
        <Menu.Divider/>
        <Menu.Item key='1'>
          <a onClick={this.openModal}>
            <FontAwesomeIcon icon='sign-out-alt'/> Log Out
          </a>
        </Menu.Item>
        {hijack && <Menu.Divider/>}
        {hijack &&
          <Menu.Item key='2'>
            <Input styleName='hijack-input' onChange={this.handleChange} value={user.hijack_email} onPressEnter={this.hijack}/>
            <Button type='primary' size='small' onClick={this.hijack} loading={user.loading}>Hijack</Button>
          </Menu.Item>
        }
      </Menu>
    )

    return(
      <Dropdown
        overlay={menu}
        trigger={['click']}
        placement='bottomLeft'
        onVisibleChange={this.handleVisibleChange}
        visible={this.state.dropdown}
      >
        <span styleName={`title${this.state.dropdown ? '-dropdown' : ''}`}>
          <LogoutModal
            visible={this.state.modal}
            close={this.closeModal}
          />
          <Avatar size='large' styleName='avatar'>{letter}</Avatar>
          <span styleName='info'>
            <span styleName='name'>{name}</span>
            <span styleName='plan'>{plan}</span>
          </span>
        </span>
      </Dropdown>
    )
  }
}

export default Profile
